"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.centify = centify;

var _numberPrecision = require("number-precision");

var _travel = require("./travel");

/**
 * 变成分, 用于数据提交时
 * @description
 * 请确保数据中所有价格都进行转换
 */
function centify(data, paths) {
  return (0, _travel.travel)(data, paths, function (value) {
    return (0, _numberPrecision.times)(value, 100);
  });
}